<!-- cv简历信息表-奖项-组件级 -->
<template>
  <div class='detail-wrap'>
    <div class='detail-container'>
      <div class='cv-detail en'>
        <div v-if='awardsDetailEn.awards && awardsDetailEn.awards.length > 0'>
          <ul v-for='(item, index) in awardsDetailEn.awards'
              :key='index'>
            <li>
              <span class='cv-detail-name'>Honor Name：</span>
              <span class='cv-detail-val'>{{item.name}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Date：</span>
              <span class='cv-detail-val'>{{item.time}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Grade Level：</span>
              <!-- <span class='cv-detail-val'>{{item.grades && new Map(gradeEnMap).get(item.grades)}}</span> -->
              <span class='cv-detail-val'
                    v-if='item.grades && item.grades.length > 0'><span v-for='(grade, idx) in item.grades'
                      :key='idx'>{{new Map(gradeEnMap).get(grade)}}<span v-if='idx !== item.grades.length - 1'>,&nbsp;&nbsp;</span></span></span>
            </li>
            <li>
              <span class='cv-detail-name'>Level of Recognition：</span>
              <span class='cv-detail-val'>{{item.level && new Map(awardLevelEnMap).get(item.level)}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Issued by：</span>
              <span class='cv-detail-val'>{{item.issuedBy}}</span>
            </li>
            <li>
              <span class='cv-detail-name'>Description：</span>
              <span class='cv-detail-val'>{{item.description}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cvService from '@/api/undergraduate/cv'
import { gradeEnMap, awardLevelEnMap } from '../constants'
import './cv-detail.less'
export default {
  name: '',
  components: {},
  data () {
    return {
      // 年级映射
      gradeEnMap,
      // 奖项级别映射
      awardLevelEnMap,
      // 学员num
      menteeNum: '',
      // 奖项详情
      awardsDetailEn: {}
    }
  },
  computed: {},
  mounted () {
    this.menteeNum = this.$route.params.id
    this.getAwardsDetailEn()
  },
  methods: {
    // 获取奖项-en
    getAwardsDetailEn () {
      cvService.cvAwardsDetailEn({ num: this.menteeNum }).then(res => {
        if (res.data.model) {
          this.awardsDetailEn = res.data.model
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
